module.exports = __webpack_public_path__ + "media/services/smart-manage-icon-a60e6127.svg";